import { UserCompanies } from '../companies/user-companies.model';
import { UserErpPermission } from './user-erp-permission.model';
import { UserConfiguration } from 'app/@core/services/conf/configuration.service';
export class User {
  // Note: Using only optional constructor properties without backing store disables typescript's type checking for the type
  constructor(id?: string, userName?: string, fullName?: string, email?: string, jobTitle?: string, phoneNumber?: string, roles?: string[],
    companies?: UserCompanies[], userErpPermission?: UserErpPermission[]) {

    this.id = id;
    this.userName = userName;
    this.fullName = fullName;
    this.email = email;
    this.jobTitle = jobTitle;
    this.phoneNumber = phoneNumber;
    this.roles = roles;
    this.userCompanies = companies;
    this.userErpPermission = userErpPermission;
  }


  get friendlyName(): string {
    let name = this.fullName || this.userName;

    if (this.jobTitle) {
      name = this.jobTitle + ' ' + name;
    }

    return name;
  }


  public id: string;
  public userName: string;
  public fullName: string;
  public email: string;
  public jobTitle: string;
  public phoneNumber: string;
  public isEnabled: boolean;
  public isLockedOut: boolean;
  public roles: string[];
  public userCompanies: UserCompanies[];
  public userErpPermission: UserErpPermission[];
  public userConfiguration?: UserConfiguration;
}
